import { apiRequest } from "../util/apiUtils";

export const userList = async (params) => {
  try {
    const res = await apiRequest("get", `user/list`, {
      queries: params,
    });

    return res?.data;
  } catch (err) {
    throw err;
  }
};

export const userAddEdit = async (payload) => {
  try {
    const res = await apiRequest(
      payload?.id ? "put" : "post",
      `user/${payload?.id ? "edit" : "add"}`,
      {
        body: payload,
      },
      "multipart/form-data"
    );

    return res?.data;
  } catch (err) {
    throw err;
  }
};

export const userDetails = async (payload) => {
  try {
    const res = await apiRequest("get", `user/detail/${payload?.id}`);

    return res?.data;
  } catch (err) {
    throw err;
  }
};

export const userDelete = async (payload) => {
  try {
    const res = await apiRequest("patch", `user/delete-all`, {
      body: payload,
    });

    return res?.data;
  } catch (err) {
    throw err;
  }
};

export const userStatusChange = async (payload) => {
  try {
    const res = await apiRequest("patch", `user/status`, {
      body: payload,
    });

    return res?.data;
  } catch (err) {
    throw err;
  }
};

export const userPasswordChange = async (payload) => {
  try {
    const res = await apiRequest("patch", `user/admin-password-change`, {
      body: payload,
    });

    return res?.data;
  } catch (err) {
    throw err;
  }
};

export const logInAsHandler= async (payload) => {
  try {
    const res = await apiRequest("post", `user/login-as`, {
      body: payload,
    });

    return res?.data;
  } catch (err) {
    throw err;
  }
};
